export const formItemLayout = {
    marginTop: 12,
    labelCol: {
        xs: { span: 12 },
        sm: { span: 24 },
        md: { span: 10 },
        lg: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 14 },
        lg: { span: 17 },
    },
};
export const checkboxItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 12 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 9 },
    },
};
export const bike_types = [
    { value: 'Adventure', label: 'Adventure' },
    { value: 'Classic', label: 'Classic' },
    { value: 'Commuter', label: 'Commuter' },
    { value: 'Custom Cruiser', label: 'Custom Cruiser' },
    { value: 'Enduro', label: 'Enduro' },
    { value: 'Moped', label: 'Moped' },
    { value: 'Naked', label: 'Naked' },
    { value: 'Scooter', label: 'Scooter' },
    { value: 'Sports Tourer', label: 'Sports Tourer' },
    { value: 'Super Moto', label: 'Super Moto' },
    { value: 'Super Sports', label: 'Super Sports' },
    { value: 'Tourer', label: 'Tourer' },
    { value: 'Trail Bike', label: 'Trail Bike' },
    { value: 'Trial Bike', label: 'Trial Bike' },
];



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_create/components/statics.js